import { createFileRoute } from "@tanstack/react-router";

import { AdminReviewQueuePage } from "@/components/AdminReviewPage";

// /admin/review — первая из очереди проверки или «Всё проверено ✓». noindex.
export const Route = createFileRoute("/admin_/review/")({
  head: () => ({ meta: [{ title: "Проверка — Yolutap" }, { name: "robots", content: "noindex, nofollow" }] }),
  component: AdminReviewQueuePage,
});
